<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('reports.reports.ShiftReport') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-file-text"></i>
          <span>{{ $ml.get('shared.reports') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('reports.reports.ShiftReport') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li :class="activeScreen == 1 ? 'active' : ''">
                <a @click="activeScreen = 1" style="cursor:pointer;">
                  <i class="fa fa-filter"></i> {{ $ml.get('filters.filterEmployees') }}
                </a>
              </li>
              <li :class="activeScreen == 2 ? 'active' : ''">
                <a @click="activeScreen = 2" style="cursor:pointer;">
                  <i class="fa fa-cogs"></i> {{ $ml.get('reports.reportSettings') }}
                </a>
              </li>
              <li :class="activeScreen == 3 ? 'active' : ''">
                <a @click="activeScreen = 3" style="cursor:pointer;">
                  <i class="fa fa-file-text"></i> {{ $ml.get('reports.report') }}
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div v-show="activeScreen == 1" :class="activeScreen == 1 ? 'row tab-pane active' : 'row tab-pane'"
                style="margin-top: 10px;"><!-- KİŞİ FİLTRE -->
                <div class="col-sm-8">
                  <div class="box box-danger">
                    <div class="box-header">
                      <h3 class="box-title" align="center">{{ $ml.get('filters.filterEmployees') }}</h3>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                            <input v-model="filters.nameOrCardNumber" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                            <input v-model="filters.identityNo" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterCitizenshipNumber')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                            <input v-model="filters.sicilOrTerminalNo" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')"
                              style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                            <input v-model="filters.documentNoOrMail" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterDocumentNoOrEmail')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group" v-show="modules.licencePlateRecognition">
                            <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                            <input v-model="filters.plateNo" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterPlateNo')" style="margin-bottom:5px;" />
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterTitle') }}</span>
                            <select @change="changeFilterTitles($event)" class="form-control input-sm"
                              style="margin-bottom:5px;">
                              <option :selected="filters.title == ''" value>{{ $ml.get('general.select') }}</option>
                              <option v-for="(title, index) in titleList" :key="'title' + index" :value="title.name"
                                :selected="title.name == filters.title">{{ title.name }}</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <span>{{ $ml.get('filters.filterDeleted') }}</span>
                            <span class="form-control checkbox">
                              <label style="margin-left:20px;">
                                <input :checked="filters.isActive"
                                  @change="filters.isActive == true ? filters.isActive = false : filters.isActive = true"
                                  type="checkbox" />
                                {{ $ml.get('filters.filterNotShow') }}
                              </label>
                            </span>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterStatus') }}</label>
                            <div class="input-group">
                              <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList
                              }}</label>
                              <label v-show="checkedStatusList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                              }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedStatusList != ''" class="btn btn-danger"
                                  @click="clearFilterStatus()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterDepartments') }}</label>
                            <div class="input-group">
                              <label v-show="checkedDepartmentList != ''" class="form-control tdb-box">{{
                                checkedDepartmentList
                              }}</label>
                              <label v-show="checkedDepartmentList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                              }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal"
                                  data-target="#modal-select-department">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                                  @click="clearFilterDepartments()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                            <div class="input-group">
                              <label v-show="checkedAccessGroupList != ''" class="form-control tdb-box">{{
                                checkedAccessGroupList
                              }}</label>
                              <label v-show="checkedAccessGroupList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                              }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                                  @click="clearFilterAccessGroup()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                            <div class="input-group">
                              <label v-show="checkedWorkGroupList != ''" class="form-control tdb-box">{{
                                checkedWorkGroupList
                              }}</label>
                              <label v-show="checkedWorkGroupList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                              }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal"
                                  data-target="#modal-select-workplan">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                                  @click="clearFilterWorkPlans()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-show="modules.diningHall">
                            <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                            <div class="input-group">
                              <label v-show="checkedFoodGroupList != ''" class="form-control tdb-box">{{
                                checkedFoodGroupList
                              }}</label>
                              <label v-show="checkedFoodGroupList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                              }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal"
                                  data-target="#modal-select-diningHall">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                                  @click="clearFilterFoodGroups()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label>{{ $ml.get('filters.filterState') }}</label>
                            <div class="input-group">
                              <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList
                              }}</label>
                              <label v-show="checkedStateList == ''" class="form-control">{{
                                $ml.get('general.notSelected')
                              }}</label>
                              <div class="input-group-btn">
                                <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                                  <i class="fa fa-search"></i>
                                </button>
                                <button v-show="checkedStateList != ''" class="btn btn-danger"
                                  @click="clearFilterStates()">
                                  <i class="fa fa-remove"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="callout callout-info" style="margin-top:10px;">
                        <div class="row">
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField1($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField1key == 0" value="0">{{
                                $ml.get('filters.filterSelectExtraFields')
                              }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField1-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField1key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField1value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField2($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField2key == 0" value="0">{{
                                $ml.get('filters.filterSelectExtraFields')
                              }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField2-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField2key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField2value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField3($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField3key == 0" value="0">{{
                                $ml.get('filters.filterSelectExtraFields')
                              }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField3-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField3key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField3value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                          <div class="col-sm-3">
                            <select @change="changeFilterExtraField4($event)" class="form-control input-sm text-center"
                              style="margin-bottom:5px; text-align:center;">
                              <option :selected="filters.extraField4key == 0" value="0">{{
                                $ml.get('filters.filterSelectExtraFields')
                              }}
                              </option>
                              <option v-for="extraField in extraFieldList" :key="'extraField4-' + extraField.id"
                                :value="extraField.id" :selected="extraField.id == filters.extraField4key">{{
                                  extraField.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <input v-model="filters.extraField4value" type="text" class="form-control input-sm"
                              :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box-footer text-right">
                      <button @click="filtersClear()" class="btn btn-warning">
                        <i class="fa fa-trash-o"></i>
                        <span>{{ $ml.get('filters.filterClear') }}</span>
                      </button>
                      <button @click="getEmployees()" class="btn btn-success">
                        <i class="fa fa-search"></i>
                        <span>{{ $ml.get('filters.filterApply') }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title" style="display: flex; justify-content: space-between; align-items: center;">
                        <span>Seçilen Kişiler</span>
                        <a @click="checkEmployees()" style="cursor:pointer;font-size:15px;">
                          <span v-show="!isCheck">{{ $ml.get('general.selectAll') }}</span>
                          <span v-show="isCheck">{{ $ml.get('general.removeAll') }}</span>
                        </a>
                      </h4>
                      <div class="form-group" style="margin-top: 10px;">
                        <input v-model="searchText" class="form-control"
                          :placeholder="$ml.get('filters.searchEmployeeFromList')" />
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="employeeFilteredList.length > 0" class="table-responsive no-padding"
                        :style="windowHeightTableSize">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <td></td>
                              <td @click="setOrderEmp(1)" style="cursor:pointer;min-width:75px;">
                                <strong>
                                  {{ $ml.get('employees.registrationNumberInfo') }}
                                  <i v-show="orderEmpList == 1" class="fa fa-sort-numeric-asc"></i>
                                  <i v-show="orderEmpList == 2" class="fa fa-sort-numeric-desc"></i>
                                </strong>
                              </td>
                              <td @click="setOrderEmp(2)" style="cursor:pointer;">
                                <strong>
                                  {{ $ml.get('employees.nameSurname') }}
                                  <i v-show="orderEmpList == 3" class="fa fa-sort-alpha-asc"></i>
                                  <i v-show="orderEmpList == 4" class="fa fa-sort-alpha-desc"></i>
                                </strong>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style="cursor:pointer;" v-for="employee3 in filtered" :key="'employee' + employee3.id"
                              @click="employee3.check == true ? employee3.check = false : employee3.check = true">
                              <td style="font-size:18px;">
                                <i v-if="employee3.check" class="fa fa-check-circle text-success"></i>
                                <i v-else class="fa fa-times-circle text-danger"></i>
                              </td>
                              <td>{{ employee3.sicilNo }}</td>
                              <td>
                                {{ employee3.name }}
                                <span v-if="employee3.title != ''">({{ employee3.title }})</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="employeeFilteredList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('filters.employeeNotRecord') }}
                      </div>
                    </div>
                    <div class="overlay" id="load" :hidden="!isLoadingEmployee">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn btn-primary" @click="activeScreen = 2">
                    <i class="fa fa-check"></i>
                    <span>{{ $ml.get('filters.filterComplete') }}</span>
                  </button>
                </div>
              </div>
              <div v-show="activeScreen == 2" :class="activeScreen == 2 ? 'row tab-pane active' : 'row tab-pane'"
                style="margin-top: 10px;"><!-- RAPOR AYARLARI -->
                <div class="col-sm-12">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title" align="center">{{ $ml.get('reports.reportSettings') }}</h3>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="input-group" style="width:100%; margin-bottom:5px;">
                            <span class="input-group-addon">
                              <span>{{ $ml.get('reports.startDate') }}:</span>
                            </span>
                            <input v-model="startDate" type="datetime-local" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="input-group" style="margin-bottom:5px;">
                            <span class="input-group-addon">{{ $ml.get('reports.endDate') }} :</span>
                            <input v-model="endDate" type="datetime-local" class="form-control" />
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <span class="form-control checkbox">
                              <label style="margin-left:20px;">
                                <input :checked="isSignatureColumnAdded"
                                  @change="isSignatureColumnAdded = !isSignatureColumnAdded"
                                  type="checkbox" />
                                {{$ml.get("reports.reports.ShiftReportHeaders.isSignatureColumnAdded")}}
                              </label>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box-footer text-right">
                      <button @click="getReportDetails()" class="btn btn-primary">
                        <i class="fa fa-file-text"></i>
                        {{ $ml.get('reports.viewReport') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeScreen == 3" :class="activeScreen == 3 ? 'row tab-pane active' : 'row tab-pane'"
                style="margin-top: 10px;"><!-- RAPOR SONUCU -->
                <div class="col-sm-12">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title" align="center">
                        <span v-show="selectedReportName != ''">{{ selectedReportName }}</span>
                        <span v-show="selectedReportName == ''">{{ $ml.get('reports.report') }}</span>
                      </h3>
                      <div class="box-tools pull-right" v-show="authControl == 0 && reportDataList != null">
                        <button @click="exportToExcel()" type="button" class="btn btn-success">
                          <i class="fa fa-share"></i>
                          {{ $ml.get('general.exportToExcel') }}
                        </button>
                        <button @click="exportToPDF()" type="button" class="btn btn-danger">
                          <i class="fa fa-share"></i>
                          {{ $ml.get('general.exportToPdfOrPrint') }}
                        </button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div id="printReport" v-show="reportDataList != null" class="table-responsive no-padding"
                        :style="windowHeightSize">
                        <div align="center">
                          <span class="mb-10 text-center" v-show="selectedReportName != ''">{{ selectedReportName }}
                            ({{ this.startDate | toDateFormatGet("gg.aa.yyyy ss:dd") }} - {{ this.endDate |
                              toDateFormatGet("gg.aa.yyyy ss:dd") }})</span>
                        </div>
                        <table id="printExcel" class="table table-hover" style="font-size:12px;">
                          <thead>
                            <tr>
                              <th class="dep-baslik" v-for="(header, indexHead) in reportHeaderList"
                                :key="'head' + indexHead">
                                {{ header }}</th>
                            </tr>
                          </thead>
                          <tbody v-for="(dep, index) in reportDataList" :key="'body' + index">
                            <tr>
                              <td class="dep-baslik" colspan="37">
                                <strong>{{ dep.departmanAdi }}</strong>
                              </td>
                            </tr>
                            <tr v-for="(data, index2) in dep.veriler" :key="'data' + index2"
                              :class="index2 % 2 == 1 ? 'bg-secondary' : ''">
                              <td>{{ data.registerNo }}</td>
                              <td>{{ data.name }}</td>
                              <td>{{ data.title }}</td>
                              <td v-for="(plan, index) in data.plans" :key="'plan' + index"
                                class="no-wrap">
                                {{ plan.name }}
                              </td>
                              <td v-show="isSignatureColumnAdded" style="min-width: 150px;"></td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="pull-right" style="margin-right: 70px; margin-bottom: 40px;">
                          <!--<strong>Toplam Kayıt :</strong>
                  <span
                    v-text="reportDataList != null || reportDataList == 0 ? reportDataList.length : 0"
                  ></span>-->
                        </div>
                      </div>
                      <div v-show="reportDataList == null || reportDataList == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('reports.noResults') }}
                      </div>
                    </div>
                    <div class="overlay" id="load" :hidden="!isLoading">
                      <i class="fa fa-refresh fa-spin"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterDepartments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
              </a>
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="'sortDep' + dep.id">
                  <label style="margin-left:20px;">
                    <input :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox" />
                    {{ dep.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                  {{ $ml.get('employees.departmentNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" M data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterState') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="'state' + state.id">
                  <label style="margin-left:20px;">
                    <input :checked="state.isCheck"
                      @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                    {{ state.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="stateList.length == 0">
                  {{ $ml.get('employees.stateNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterStatus') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="'status' + status.id">
                  <label style="margin-left:20px;">
                    <input :checked="status.isCheck"
                      @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true"
                      type="checkbox" />
                    {{ status.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="statuList.length == 0">
                  {{ $ml.get('employees.statusNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="'access' + acc.id">
                  <label style="margin-left:20px;">
                    <input :checked="acc.isCheck"
                      @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true" type="checkbox" />
                    {{ acc.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                  {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="work in workGroupList" :key="'workGroup' + work.id">
                  <label style="margin-left:20px;">
                    <input :checked="work.isCheck"
                      @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true" type="checkbox" />
                    {{ work.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="workGroupList.length == 0">
                  {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="foodGroup in foodGroupList"
                  :key="'foodGroup' + foodGroup.id">
                  <label style="margin-left:20px;">
                    <input :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                      type="checkbox" />
                    {{ foodGroup.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                  {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingEmployee: false,
      activeScreen: 1,
      orderEmpList: 1,
      selectedDoorType: 4,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      sortableDepTrees: [],
      isCheckDeps: false,
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      startDate: null,
      endDate: null,
      selectedReportId: 35,
      selectedReportEndPoint: "ShiftReport",
      selectedReportName: "",
      selectedDevices: [],
      selectedAllowences: [],
      selectedVisitorGroups: [],
      reportOptions: {
        showAllowed: true,
        showNonComers: true,
        showLateComers: false,
        isUpperFromTime: false,
        time: 45
      },
      isSignatureColumnAdded: false,
      reportDatas: null,
      reportHeaders: null,
      reportResult: [],
      reportName: "",
      searchText: "",
    };
  },
  computed: {
    defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthRaporlar;
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeFilteredList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.sicilNo).localeCompare(
            this.turkishToUpper(b.sicilNo)
          );
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.sicilNo).localeCompare(
            this.turkishToUpper(a.sicilNo)
          );
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.name).localeCompare(
            this.turkishToUpper(b.name)
          );
        });
      } else {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.name).localeCompare(
            this.turkishToUpper(a.name)
          );
        });
      }
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    titleList() {
      return this.titles;
    },
    stateList() {
      return this.states;
    },
    statuList() {
      return this.status;
    },
    reportDataList() {
      return this.reportDatas;
    },
    reportHeaderList() {
      return this.reportHeaders;
    },
    extraFieldList() {
      return this.extrafields;
    },
    workGroupList() {
      return this.workGroups;
    },
    allowenceList() {
      return this.allowences;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    filtered() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeFilteredList.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v));
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 300;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 380;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye =
            str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat =
            str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika =
            str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "gg.aa.yyyy GG") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    customReportStyle(key, value) {
      if (key == "durum") {
        if (value == "Gelmedi") {
          return "color-danger no-wrap";
        } else if (
          value == "Geç Kaldı" ||
          value == "Hafta Tatili" ||
          value == "Cumartesi Hakedişi"
        ) {
          return "color-warning no-wrap";
        } else if (value == "Geldi") {
          return "color-success no-wrap";
        } else {
          return "color-primary no-wrap";
        }
      } else if (
        (key == "name" && value == "Toplam") ||
        (key == "date" && value == "Toplam")
      ) {
        return "text-bold h5";
      } else if (key == "unitName") {
        return "text-bold";
      } else if (
        key == "employeesInDepartments" ||
        key == "continuedEmployee" ||
        key == "annualPermit" ||
        key == "report" ||
        key == "missioned" ||
        key == "administrativeLeave" ||
        key == "nonComers" ||
        key == "todayComers" ||
        key == "freePermission"
      ) {
        return "text-bold text-center";
      } else if (key == "adSoyad" || key == "name") {
        return "min-180";
      } else if (key == "total" || key == "ucret" || key == "allowenceName") {
        return "text-bold";
      } else if (key == "g1" && value != "") {
        return "color-success";
      } else if (key == "c1" && value != "") {
        return "color-danger";
      } else if (key == "g2" && value != "") {
        return "color-success";
      } else if (key == "c2" && value != "") {
        return "color-danger";
      } else if (key == "g3" && value != "") {
        return "color-success";
      } else if (key == "c3" && value != "") {
        return "color-danger";
      } else if (key == "g4" && value != "") {
        return "color-success";
      } else if (key == "c4" && value != "") {
        return "color-danger";
      } else if (key == "g5" && value != "") {
        return "color-success";
      } else if (key == "c5" && value != "") {
        return "color-danger";
      } else if (key == "g6" && value != "") {
        return "color-success";
      } else if (key == "c6" && value != "") {
        return "color-danger";
      } else if (key == "g7" && value != "") {
        return "color-success";
      } else if (key == "c7" && value != "") {
        return "color-danger";
      } else if (key == "g8" && value != "") {
        return "color-success";
      } else if (key == "c8" && value != "") {
        return "color-danger";
      } else if (key == "g9" && value != "") {
        return "color-success";
      } else if (key == "c9" && value != "") {
        return "color-danger";
      } else if (key == "g10" && value != "") {
        return "color-success";
      } else if (key == "c10" && value != "") {
        return "color-danger";
      } else if (
        key == "employeesInDepartments" ||
        key == "annualPermit" ||
        key == "report" ||
        key == "administrativeLeave" ||
        key == "freePermission" ||
        key == "missioned" ||
        key == "nonComers" ||
        key == "todayComers" ||
        key == "d1" ||
        key == "d2" ||
        key == "d3" ||
        key == "d4" ||
        key == "d5" ||
        key == "d6" ||
        key == "d7" ||
        key == "d8" ||
        key == "d9" ||
        key == "d10" ||
        key == "d11" ||
        key == "d12" ||
        key == "d13" ||
        key == "d14" ||
        key == "d15" ||
        key == "d16" ||
        key == "d17" ||
        key == "d18" ||
        key == "d19" ||
        key == "d20" ||
        key == "d21" ||
        key == "d22" ||
        key == "d23" ||
        key == "d24" ||
        key == "d25" ||
        key == "d26" ||
        key == "d27" ||
        key == "d28" ||
        key == "d29" ||
        key == "d30" ||
        key == "d31"
      ) {
        return "text-center";
      } else if (
        key == "shortCode1" ||
        key == "shortCode2" ||
        key == "shortCode3" ||
        key == "shortCode4" ||
        key == "shortCode5" ||
        key == "shortCode6" ||
        key == "shortCode7" ||
        key == "shortCode8" ||
        key == "shortCode9" ||
        key == "shortCode10" ||
        key == "shortCode11" ||
        key == "shortCode12" ||
        key == "shortCode13" ||
        key == "shortCode14" ||
        key == "shortCode15" ||
        key == "shortCode16" ||
        key == "shortCode17" ||
        key == "shortCode18" ||
        key == "shortCode19" ||
        key == "shortCode20" ||
        key == "shortCode21" ||
        key == "shortCode22" ||
        key == "shortCode23" ||
        key == "shortCode24" ||
        key == "shortCode25" ||
        key == "shortCode26" ||
        key == "shortCode27" ||
        key == "shortCode28" ||
        key == "shortCode29" ||
        key == "shortCode30" ||
        key == "shortCode31"
      ) {
        return "text-center";
      }
    },
    checkEmployees() {
      this.isCheck = !this.isCheck;
      let aList = this.employees;
      aList.forEach(doc => {
        if (doc.check == !this.isCheck) {
          doc.check = this.isCheck;
        }
      });
    },
    async getSelectedEmployeeList() {
      let aList = this.employees;
      let selectedEmployees = aList.filter(function (employee) {
        return employee.check == true;
      });
      let selectedEmployeeList = [];
      await selectedEmployees.forEach(emp => {
        selectedEmployeeList.push(emp.id);
      });
      return selectedEmployeeList;
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.workGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    changeIsUpperFromTime(event) {
      this.reportOptions.isUpperFromTime = event.target.value;
    },
    changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    exportToExcel() {
      var tarih = new Date();
      var filename = this.selectedReportName + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                userId: doc.userId,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let departments2 = this.departments;
      let subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          doc2.name = ekle + " " + doc2.name;
          this.sortableDepTrees.push(doc2);
          this.subDepImport(doc2);
        });
      }
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async changeFilterDep2(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          //this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async clearFilterDepartments() {
      this.filters.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.filters.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.filters.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.filters.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.filters.workGroupId = [];
      await this.workGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.filters.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.filters.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.workGroupList;
      this.filters.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.filters.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.filters.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.filters.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.stateId.push(doc.id);
        }
      });
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async reportSetting() {
      if (this.reportResult != [] && this.reportResult != null) {
        //Vardiya Raporu
        this.reportHeaders = [];
        this.reportHeaders.push(
          this.$ml.get(
            "reports.reports.ShiftReportHeaders.registrationNumber"
          )
        );
        this.reportHeaders.push(
          this.$ml.get(
            "reports.reports.ShiftReportHeaders.nameSurname"
          )
        );
        this.reportHeaders.push(
          this.$ml.get(
            "reports.reports.ShiftReportHeaders.title"
          )
        );
        var keys = [
          "departmentName",
          "total"
        ];
        this.reportDatas = [];
        var movementsMaxLength = 0;
        this.reportResult.forEach(item => {
          if (item.veriler.length > 0) {
            this.reportDatas.push({
              departmanAdi: item.departmanAdi,
              keys: keys,
              veriler: item.veriler
            });
          }
        });
        var tempDate = new Date(this.startDate);
        var endDate = new Date(this.endDate);
        for(var i = 0; tempDate <= endDate; i++) {
          this.reportHeaders.push(tempDate.toLocaleDateString("tr-TR", { day: '2-digit', month: '2-digit', year: 'numeric' }));
          tempDate.setDate(tempDate.getDate() + 1);
        }
        if(this.isSignatureColumnAdded) {
          this.reportHeaders.push(
            this.$ml.get(
              "reports.reports.ShiftReportHeaders.signature"
            )
          );
        }
      } else {
        this.reportHeaders = null;
        this.reportDatas = null;
      }
    },
    async getReportDetails() {
      if (
        this.startDate == null ||
        this.endDate == null ||
        this.startDate > this.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.activeScreen = 3;
        this.isLoading = true;
        let empIds = await this.getSelectedEmployeeList();
        let reportEndPoint = this.selectedReportEndPoint;
        let startDate = this.startDate;
        let endDate = this.endDate;
        var reportOption = {
          empIds: empIds,
          startDate: startDate,
          endDate: endDate
        };
        const response = await this.$axios
          .post("/Reports/" + reportEndPoint, reportOption)
          .then(response => {
            this.reportResult = response.data.datas;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        await this.reportSetting();
        this.reportName =
          this.selectedReportName +
          " (" +
          this.toDateFormat(this.startDate, "gg.aa.yyyy ss:dd") +
          " - " +
          this.toDateFormat(this.endDate, "gg.aa.yyyy ss:dd") +
          ")";
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getEmployees() {
      try {
        this.isLoadingEmployee = true;
        await this.getCheckDepartmentList();
        const employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              employees.push({
                id: doc.id,
                name: doc.name,
                sicilNo: doc.sicilNo,
                title: doc.title,
                check: true
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    setUserAuthorityFilter(filter) {
      filter.accessGroup
        ? (this.filters.accessGroup = filter.accessGroup)
        : (this.filters.accessGroup = []);
      filter.foodGroup
        ? (this.filters.foodGroup = filter.foodGroup)
        : (this.filters.foodGroup = []);
      filter.workGroupId
        ? (this.filters.workGroupId = filter.workGroupId)
        : (this.filters.workGroupId = []);
      filter.stateId
        ? (this.filters.stateId = filter.stateId)
        : (this.filters.stateId = []);
      filter.statuId
        ? (this.filters.statuId = filter.statuId)
        : (this.filters.statuId = []);
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        this.filters.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(doc => {
        this.filters.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.filters.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.filters.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.filters.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.filters.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(this.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getDefaultDate();
    await this.getDepartments();
    await this.getAccessGroups();
    await this.getFoodGroups();
    await this.getStatus();
    await this.getStates();
    await this.getTitles();
    await this.getWorkGroups();
    await this.getExtraFields();
    if (this.defaultFilters) {
      var filter = this.defaultFilters;
      this.setUserAuthorityFilter(filter);
      await this.getEmployees();
    } else {
      await this.getEmployees();
    }
  }
};
</script>

<style scoped>
.dep-baslik {
  font-weight: bold;
  background-color: #3c8dbc;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/pages/reports/ShiftReport.vue